import React from "react";

/**
 * Pins its children (the page's primary CTA button) to the bottom of the
 * viewport so the action stays visible while the rest of the page/form
 * scrolls underneath it.
 *
 * Usage:
 *   <StickyCtaBar>
 *     <button ...>Continue</button>
 *   </StickyCtaBar>
 *
 * Pair this with extra bottom padding (e.g. pb-[120px]) on the scrollable
 * page container so the bar never overlaps/covers the last field on screen.
 */
const StickyCtaBar = ({ children, className = "" }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 w-full pointer-events-none">
      <div
        className={`pointer-events-auto w-full max-w-[400px] mx-auto bg-white px-4 pt-3 border-t border-[#ececec] shadow-[0_-6px_16px_rgba(0,0,0,0.06)] ${className}`}
        style={{ paddingBottom: "calc(14px + env(safe-area-inset-bottom, 0px))" }}
      >
        {children}
      </div>
    </div>
  );
};

export default StickyCtaBar;
